import api from '../api'

export default {
    namespaced: true,
    state: {

    },
    mutations: {},
    actions: {
        chipDistributions(store, viewDate) {
            return api.post('/warehouseAcquisitions/chipDistributions', '金豆分布图', {viewDate})
        },
        chipGraphs(store, params) {
            return api.post('/warehouseAcquisitions/chipGraphs', '金豆曲线图', params)
        },
        chipViews(store, viewDate) {
            return api.post('/warehouseAcquisitions/chipViews', '金豆数据展示', {viewDate})
        },
        nowChipViews() {
            return api.post('/warehouseAcquisitions/chipViews/current', '当前金豆数据展示')
        },
        recentViewDate(store, params) {
            return api.post('/warehouseAcquisitions/recentViewDate', '最近一次的日期', params)
        },
        getJpbChipView(store, params) {
            return api.post('/warehouseAcquisitions/jpb/check', 'JPB仓查询', params)
        },
        getSystemChipView(store, params) {
            return api.post('/warehouseAcquisitions/system/check', '系统仓查询', params)
        }
    }
}